// This file is generated by `npm run import-icons` - don't edit it manually!
import { defineAsyncComponent } from 'vue'

export default {
  BSvg1st: defineAsyncComponent(() => import('./1st.vue')),
  BSvgAddAppointment: defineAsyncComponent(() => import('./add-appointment.vue')),
  BSvgAddLogo: defineAsyncComponent(() => import('./add-logo.vue')),
  BSvgAddText: defineAsyncComponent(() => import('./add-text.vue')),
  BSvgAdditionalMenu: defineAsyncComponent(() => import('./additional-menu.vue')),
  BSvgAddmedia: defineAsyncComponent(() => import('./addmedia.vue')),
  BSvgAdvancedOptions: defineAsyncComponent(() => import('./advanced-options.vue')),
  BSvgAdvancedSettings: defineAsyncComponent(() => import('./advanced-settings.vue')),
  BSvgAgenda: defineAsyncComponent(() => import('./agenda.vue')),
  BSvgAlertTriangle: defineAsyncComponent(() => import('./alert-triangle.vue')),
  BSvgAlert: defineAsyncComponent(() => import('./alert.vue')),
  BSvgAmericanExpress: defineAsyncComponent(() => import('./american-express.vue')),
  BSvgAppleBrandDark: defineAsyncComponent(() => import('./apple-brand-dark.vue')),
  BSvgAppleBrand: defineAsyncComponent(() => import('./apple-brand.vue')),
  BSvgArchive: defineAsyncComponent(() => import('./archive.vue')),
  BSvgArrowDown: defineAsyncComponent(() => import('./arrow-down.vue')),
  BSvgArrowLeftSmall: defineAsyncComponent(() => import('./arrow-left-small.vue')),
  BSvgArrowLeft: defineAsyncComponent(() => import('./arrow-left.vue')),
  BSvgArrowRightSmall: defineAsyncComponent(() => import('./arrow-right-small.vue')),
  BSvgArrowRight: defineAsyncComponent(() => import('./arrow-right.vue')),
  BSvgArrowUp: defineAsyncComponent(() => import('./arrow-up.vue')),
  BSvgAttach: defineAsyncComponent(() => import('./attach.vue')),
  BSvgAvatarClient: defineAsyncComponent(() => import('./avatar-client.vue')),
  BSvgAvatarGroup: defineAsyncComponent(() => import('./avatar-group.vue')),
  BSvgAvatarResource: defineAsyncComponent(() => import('./avatar-resource.vue')),
  BSvgBack: defineAsyncComponent(() => import('./back.vue')),
  BSvgBackground: defineAsyncComponent(() => import('./background.vue')),
  BSvgBackspace: defineAsyncComponent(() => import('./backspace.vue')),
  BSvgBankAccount: defineAsyncComponent(() => import('./bank-account.vue')),
  BSvgBarcode: defineAsyncComponent(() => import('./barcode.vue')),
  BSvgBasicCalendar: defineAsyncComponent(() => import('./basic-calendar.vue')),
  BSvgBcr: defineAsyncComponent(() => import('./bcr.vue')),
  BSvgBell: defineAsyncComponent(() => import('./bell.vue')),
  BSvgBillings: defineAsyncComponent(() => import('./billings.vue')),
  BSvgBlacklistSmall: defineAsyncComponent(() => import('./blacklist-small.vue')),
  BSvgBlik: defineAsyncComponent(() => import('./blik.vue')),
  BSvgBluetooth: defineAsyncComponent(() => import('./bluetooth.vue')),
  BSvgBookmark: defineAsyncComponent(() => import('./bookmark.vue')),
  BSvgBooksyApp: defineAsyncComponent(() => import('./booksy-app.vue')),
  BSvgBooksyB: defineAsyncComponent(() => import('./booksy-b.vue')),
  BSvgBoostIcon: defineAsyncComponent(() => import('./boost-icon.vue')),
  BSvgBoostOffCircle: defineAsyncComponent(() => import('./boost-off-circle.vue')),
  BSvgBoostOnCircle: defineAsyncComponent(() => import('./boost-on-circle.vue')),
  BSvgBoost: defineAsyncComponent(() => import('./boost.vue')),
  BSvgBpLight: defineAsyncComponent(() => import('./bp-light.vue')),
  BSvgBpNotificationNoShow: defineAsyncComponent(() => import('./bp-notification-no-show.vue')),
  BSvgBpNotificationReviewGood: defineAsyncComponent(() => import('./bp-notification-review-good.vue')),
  BSvgBpPerformance: defineAsyncComponent(() => import('./bp-performance.vue')),
  BSvgBreak: defineAsyncComponent(() => import('./break.vue')),
  BSvgBusinessDetails: defineAsyncComponent(() => import('./business-details.vue')),
  BSvgBusinessProfile: defineAsyncComponent(() => import('./business-profile.vue')),
  BSvgBusinessSettings: defineAsyncComponent(() => import('./business-settings.vue')),
  BSvgCalendarCancel: defineAsyncComponent(() => import('./calendar-cancel.vue')),
  BSvgCalendarClock: defineAsyncComponent(() => import('./calendar-clock.vue')),
  BSvgCalendarDay: defineAsyncComponent(() => import('./calendar-day.vue')),
  BSvgCalendarMonth: defineAsyncComponent(() => import('./calendar-month.vue')),
  BSvgCalendarParallel: defineAsyncComponent(() => import('./calendar-parallel.vue')),
  BSvgCalendarPlus: defineAsyncComponent(() => import('./calendar-plus.vue')),
  BSvgCalendarProblem: defineAsyncComponent(() => import('./calendar-problem.vue')),
  BSvgCalendarQuestion: defineAsyncComponent(() => import('./calendar-question.vue')),
  BSvgCalendarResheduled: defineAsyncComponent(() => import('./calendar-resheduled.vue')),
  BSvgCalendarWeek: defineAsyncComponent(() => import('./calendar-week.vue')),
  BSvgCalendar: defineAsyncComponent(() => import('./calendar.vue')),
  BSvgCameraFilled: defineAsyncComponent(() => import('./camera-filled.vue')),
  BSvgCamera: defineAsyncComponent(() => import('./camera.vue')),
  BSvgCancelBold: defineAsyncComponent(() => import('./cancel-bold.vue')),
  BSvgCancelThin: defineAsyncComponent(() => import('./cancel-thin.vue')),
  BSvgCancel: defineAsyncComponent(() => import('./cancel.vue')),
  BSvgCar: defineAsyncComponent(() => import('./car.vue')),
  BSvgCard: defineAsyncComponent(() => import('./card.vue')),
  BSvgCart: defineAsyncComponent(() => import('./cart.vue')),
  BSvgCashInOut: defineAsyncComponent(() => import('./cash-in-out.vue')),
  BSvgCashRegister: defineAsyncComponent(() => import('./cash-register.vue')),
  BSvgCash: defineAsyncComponent(() => import('./cash.vue')),
  BSvgCashback: defineAsyncComponent(() => import('./cashback.vue')),
  BSvgCelebrate: defineAsyncComponent(() => import('./celebrate.vue')),
  BSvgChangeOrder: defineAsyncComponent(() => import('./change-order.vue')),
  BSvgChat: defineAsyncComponent(() => import('./chat.vue')),
  BSvgCheckPromo: defineAsyncComponent(() => import('./check-promo.vue')),
  BSvgCheck: defineAsyncComponent(() => import('./check.vue')),
  BSvgCheckboxIcon: defineAsyncComponent(() => import('./checkbox-icon.vue')),
  BSvgCheckoutWithHash: defineAsyncComponent(() => import('./checkout-with-hash.vue')),
  BSvgCheckout: defineAsyncComponent(() => import('./checkout.vue')),
  BSvgChevronDownSmall: defineAsyncComponent(() => import('./chevron-down-small.vue')),
  BSvgChevronDown: defineAsyncComponent(() => import('./chevron-down.vue')),
  BSvgChevronLeftSmall: defineAsyncComponent(() => import('./chevron-left-small.vue')),
  BSvgChevronLeft: defineAsyncComponent(() => import('./chevron-left.vue')),
  BSvgChevronRightSmall: defineAsyncComponent(() => import('./chevron-right-small.vue')),
  BSvgChevronRight: defineAsyncComponent(() => import('./chevron-right.vue')),
  BSvgChevronUpSmall: defineAsyncComponent(() => import('./chevron-up-small.vue')),
  BSvgChevronUp: defineAsyncComponent(() => import('./chevron-up.vue')),
  BSvgCircleCloseFilled: defineAsyncComponent(() => import('./circle-close-filled.vue')),
  BSvgCircleClose: defineAsyncComponent(() => import('./circle-close.vue')),
  BSvgCircleHelpFilled: defineAsyncComponent(() => import('./circle-help-filled.vue')),
  BSvgCircleHelp: defineAsyncComponent(() => import('./circle-help.vue')),
  BSvgCircleInfoFilled: defineAsyncComponent(() => import('./circle-info-filled.vue')),
  BSvgCircleInfo: defineAsyncComponent(() => import('./circle-info.vue')),
  BSvgCircleShieldWarning: defineAsyncComponent(() => import('./circle-shield-warning.vue')),
  BSvgCircleTickFilled: defineAsyncComponent(() => import('./circle-tick-filled.vue')),
  BSvgCircleTick: defineAsyncComponent(() => import('./circle-tick.vue')),
  BSvgCircleWarningFilled: defineAsyncComponent(() => import('./circle-warning-filled.vue')),
  BSvgCircleWarning: defineAsyncComponent(() => import('./circle-warning.vue')),
  BSvgCircleWithStars: defineAsyncComponent(() => import('./circle-with-stars.vue')),
  BSvgCircle: defineAsyncComponent(() => import('./circle.vue')),
  BSvgClients: defineAsyncComponent(() => import('./clients.vue')),
  BSvgClockFilled: defineAsyncComponent(() => import('./clock-filled.vue')),
  BSvgClockIn: defineAsyncComponent(() => import('./clock-In.vue')),
  BSvgClockOut: defineAsyncComponent(() => import('./clock-out.vue')),
  BSvgClock: defineAsyncComponent(() => import('./clock.vue')),
  BSvgCloseCircle: defineAsyncComponent(() => import('./close-circle.vue')),
  BSvgCloseRegister: defineAsyncComponent(() => import('./close-register.vue')),
  BSvgCloseSmall: defineAsyncComponent(() => import('./close-small.vue')),
  BSvgClose: defineAsyncComponent(() => import('./close.vue')),
  BSvgCloud: defineAsyncComponent(() => import('./cloud.vue')),
  BSvgConsumption: defineAsyncComponent(() => import('./consumption.vue')),
  BSvgCopy: defineAsyncComponent(() => import('./copy.vue')),
  BSvgCreditCard: defineAsyncComponent(() => import('./credit-card.vue')),
  BSvgCup: defineAsyncComponent(() => import('./cup.vue')),
  BSvgCurrencyEur: defineAsyncComponent(() => import('./currency-eur.vue')),
  BSvgCurrencyGbp: defineAsyncComponent(() => import('./currency-gbp.vue')),
  BSvgCurrencyPercent: defineAsyncComponent(() => import('./currency-percent.vue')),
  BSvgCurrencyPln: defineAsyncComponent(() => import('./currency-pln.vue')),
  BSvgCurrencyUsd: defineAsyncComponent(() => import('./currency-usd.vue')),
  BSvgCustomFormCheckbox: defineAsyncComponent(() => import('./custom-form-checkbox.vue')),
  BSvgCustomFormInput: defineAsyncComponent(() => import('./custom-form-input.vue')),
  BSvgCustomFormText: defineAsyncComponent(() => import('./custom-form-text.vue')),
  BSvgCustomerPayments: defineAsyncComponent(() => import('./customer-payments.vue')),
  BSvgDirectionFilled: defineAsyncComponent(() => import('./direction-filled.vue')),
  BSvgDirection: defineAsyncComponent(() => import('./direction.vue')),
  BSvgDiscount: defineAsyncComponent(() => import('./discount.vue')),
  BSvgDivider: defineAsyncComponent(() => import('./divider.vue')),
  BSvgDocument: defineAsyncComponent(() => import('./document.vue')),
  BSvgDownloadGray: defineAsyncComponent(() => import('./download-gray.vue')),
  BSvgDownload: defineAsyncComponent(() => import('./download.vue')),
  BSvgDragNDrop: defineAsyncComponent(() => import('./drag-n-drop.vue')),
  BSvgDuplicate: defineAsyncComponent(() => import('./duplicate.vue')),
  BSvgEditCard: defineAsyncComponent(() => import('./edit-card.vue')),
  BSvgEditText: defineAsyncComponent(() => import('./edit-text.vue')),
  BSvgEdit: defineAsyncComponent(() => import('./edit.vue')),
  BSvgElearning: defineAsyncComponent(() => import('./elearning.vue')),
  BSvgExpand: defineAsyncComponent(() => import('./expand.vue')),
  BSvgEyeOff: defineAsyncComponent(() => import('./eye-off.vue')),
  BSvgEye: defineAsyncComponent(() => import('./eye.vue')),
  BSvgFacebookBrand: defineAsyncComponent(() => import('./facebook-brand.vue')),
  BSvgFacebook: defineAsyncComponent(() => import('./facebook.vue')),
  BSvgFilter: defineAsyncComponent(() => import('./filter.vue')),
  BSvgFilters: defineAsyncComponent(() => import('./filters.vue')),
  BSvgFinishedBreak: defineAsyncComponent(() => import('./finished-break.vue')),
  BSvgFirstVisit: defineAsyncComponent(() => import('./first-visit.vue')),
  BSvgFitCalendar: defineAsyncComponent(() => import('./fit-calendar.vue')),
  BSvgForm: defineAsyncComponent(() => import('./form.vue')),
  BSvgFormatCircle: defineAsyncComponent(() => import('./format-circle.vue')),
  BSvgFormat: defineAsyncComponent(() => import('./format.vue')),
  BSvgGeolocation: defineAsyncComponent(() => import('./geolocation.vue')),
  BSvgGiftCard: defineAsyncComponent(() => import('./gift-card.vue')),
  BSvgGift: defineAsyncComponent(() => import('./gift.vue')),
  BSvgGiftcard: defineAsyncComponent(() => import('./giftcard.vue')),
  BSvgGiftcards: defineAsyncComponent(() => import('./giftcards.vue')),
  BSvgGoogleBrand: defineAsyncComponent(() => import('./google-brand.vue')),
  BSvgGoogleBusinessProfile: defineAsyncComponent(() => import('./google-business-profile.vue')),
  BSvgGoogleCircle: defineAsyncComponent(() => import('./google-circle.vue')),
  BSvgGrab: defineAsyncComponent(() => import('./grab.vue')),
  BSvgGroupBooking: defineAsyncComponent(() => import('./group-booking.vue')),
  BSvgGroupIcon: defineAsyncComponent(() => import('./group-icon.vue')),
  BSvgHamburger: defineAsyncComponent(() => import('./hamburger.vue')),
  BSvgHash: defineAsyncComponent(() => import('./hash.vue')),
  BSvgHashtagGroup: defineAsyncComponent(() => import('./hashtag-group.vue')),
  BSvgHearFilled: defineAsyncComponent(() => import('./hear-filled.vue')),
  BSvgHeart: defineAsyncComponent(() => import('./heart.vue')),
  BSvgHelpSmall: defineAsyncComponent(() => import('./help-small.vue')),
  BSvgHelp: defineAsyncComponent(() => import('./help.vue')),
  BSvgHoliday: defineAsyncComponent(() => import('./holiday.vue')),
  BSvgHome: defineAsyncComponent(() => import('./home.vue')),
  BSvgHourglass: defineAsyncComponent(() => import('./hourglass.vue')),
  BSvgIcoBooksyBadge: defineAsyncComponent(() => import('./ico_booksy-badge.vue')),
  BSvgIcoComments: defineAsyncComponent(() => import('./ico_comments.vue')),
  BSvgIcoFb: defineAsyncComponent(() => import('./ico_fb.vue')),
  BSvgIcoIg: defineAsyncComponent(() => import('./ico_ig.vue')),
  BSvgIcoLikeFull: defineAsyncComponent(() => import('./ico_like_full.vue')),
  BSvgIcoLike: defineAsyncComponent(() => import('./ico_like.vue')),
  BSvgIcoMore: defineAsyncComponent(() => import('./ico_more.vue')),
  BSvgIcoReward: defineAsyncComponent(() => import('./ico_reward.vue')),
  BSvgIcoSend: defineAsyncComponent(() => import('./ico_send.vue')),
  BSvgIcoShare: defineAsyncComponent(() => import('./ico_share.vue')),
  BSvgIcoSquare: defineAsyncComponent(() => import('./ico_square.vue')),
  BSvgImageGray: defineAsyncComponent(() => import('./image_gray.vue')),
  BSvgImage: defineAsyncComponent(() => import('./image.vue')),
  BSvgImready: defineAsyncComponent(() => import('./imready.vue')),
  BSvgInfoSmall: defineAsyncComponent(() => import('./info-small.vue')),
  BSvgInfo: defineAsyncComponent(() => import('./info.vue')),
  BSvgInstagramBrand: defineAsyncComponent(() => import('./instagram-brand.vue')),
  BSvgInstagram: defineAsyncComponent(() => import('./instagram.vue')),
  BSvgInventoryReport: defineAsyncComponent(() => import('./inventory-report.vue')),
  BSvgInventory: defineAsyncComponent(() => import('./inventory.vue')),
  BSvgInviteClient: defineAsyncComponent(() => import('./invite-client.vue')),
  BSvgInviteCustomersOffCircle: defineAsyncComponent(() => import('./invite-customers-off-circle.vue')),
  BSvgInviteCustomersOnCircle: defineAsyncComponent(() => import('./invite-customers-on-circle.vue')),
  BSvgJumpstart: defineAsyncComponent(() => import('./jumpstart.vue')),
  BSvgKeyedInPayment: defineAsyncComponent(() => import('./keyed-in-payment.vue')),
  BSvgLayers: defineAsyncComponent(() => import('./layers.vue')),
  BSvgLeftTop: defineAsyncComponent(() => import('./left-top.vue')),
  BSvgLight: defineAsyncComponent(() => import('./light.vue')),
  BSvgLinkOut: defineAsyncComponent(() => import('./link-out.vue')),
  BSvgLinkSmall: defineAsyncComponent(() => import('./link-small.vue')),
  BSvgLocation: defineAsyncComponent(() => import('./location.vue')),
  BSvgLockFilled: defineAsyncComponent(() => import('./lock-filled.vue')),
  BSvgLock: defineAsyncComponent(() => import('./lock.vue')),
  BSvgLogout: defineAsyncComponent(() => import('./logout.vue')),
  BSvgLoyaltyProgram: defineAsyncComponent(() => import('./loyalty-program.vue')),
  BSvgMagicStars: defineAsyncComponent(() => import('./magic-stars.vue')),
  BSvgMail: defineAsyncComponent(() => import('./mail.vue')),
  BSvgMarketing: defineAsyncComponent(() => import('./marketing.vue')),
  BSvgMed: defineAsyncComponent(() => import('./med.vue')),
  BSvgMembership: defineAsyncComponent(() => import('./membership.vue')),
  BSvgMergeFilled: defineAsyncComponent(() => import('./merge-filled.vue')),
  BSvgMerge: defineAsyncComponent(() => import('./merge.vue')),
  BSvgMessageBlastOffCircle: defineAsyncComponent(() => import('./message-blast-off-circle.vue')),
  BSvgMessageBlastOnCircle: defineAsyncComponent(() => import('./message-blast-on-circle.vue')),
  BSvgMessageEdit: defineAsyncComponent(() => import('./message-edit.vue')),
  BSvgMessageSearch: defineAsyncComponent(() => import('./message-search.vue')),
  BSvgMessage: defineAsyncComponent(() => import('./message.vue')),
  BSvgMinusSmall: defineAsyncComponent(() => import('./minus-small.vue')),
  BSvgMinus: defineAsyncComponent(() => import('./minus.vue')),
  BSvgMobilePayment: defineAsyncComponent(() => import('./mobile-payment.vue')),
  BSvgMobileServices: defineAsyncComponent(() => import('./mobile-services.vue')),
  BSvgMobile: defineAsyncComponent(() => import('./mobile.vue')),
  BSvgModalCircleError: defineAsyncComponent(() => import('./modal-circle-error.vue')),
  BSvgModalCircleInfo: defineAsyncComponent(() => import('./modal-circle-info.vue')),
  BSvgModalCirclePositive: defineAsyncComponent(() => import('./modal-circle-positive.vue')),
  BSvgModalCircleQuestion: defineAsyncComponent(() => import('./modal-circle-question.vue')),
  BSvgModalCircleUser: defineAsyncComponent(() => import('./modal-circle-user.vue')),
  BSvgModalCircleWarning: defineAsyncComponent(() => import('./modal-circle-warning.vue')),
  BSvgMore: defineAsyncComponent(() => import('./more.vue')),
  BSvgMoveArrows: defineAsyncComponent(() => import('./move-arrows.vue')),
  BSvgNavArrowLeft: defineAsyncComponent(() => import('./nav-arrow-left.vue')),
  BSvgNavArrowRight: defineAsyncComponent(() => import('./nav-arrow-right.vue')),
  BSvgNewSale: defineAsyncComponent(() => import('./new-sale.vue')),
  BSvgNoResources: defineAsyncComponent(() => import('./no-resources.vue')),
  BSvgNoResults: defineAsyncComponent(() => import('./no-results.vue')),
  BSvgNoShowProtection: defineAsyncComponent(() => import('./no-show-protection.vue')),
  BSvgNoshow: defineAsyncComponent(() => import('./noshow.vue')),
  BSvgNote: defineAsyncComponent(() => import('./note.vue')),
  BSvgNotificationTrophy: defineAsyncComponent(() => import('./notification_trophy.vue')),
  BSvgOnlineBooking: defineAsyncComponent(() => import('./online-booking.vue')),
  BSvgOtherPaymentMethod: defineAsyncComponent(() => import('./other-payment-method.vue')),
  BSvgOther: defineAsyncComponent(() => import('./other.vue')),
  BSvgPackage: defineAsyncComponent(() => import('./package.vue')),
  BSvgPadlockKey: defineAsyncComponent(() => import('./padlock_key.vue')),
  BSvgPaperClipCircle: defineAsyncComponent(() => import('./paper-clip-circle.vue')),
  BSvgPaperClip: defineAsyncComponent(() => import('./paper-clip.vue')),
  BSvgParagraph: defineAsyncComponent(() => import('./paragraph.vue')),
  BSvgParallelFilled: defineAsyncComponent(() => import('./parallel-filled.vue')),
  BSvgParallel: defineAsyncComponent(() => import('./parallel.vue')),
  BSvgPartnerApps: defineAsyncComponent(() => import('./partner-apps.vue')),
  BSvgPartnerFizjorejestracja: defineAsyncComponent(() => import('./partner-fizjorejestracja.vue')),
  BSvgPause: defineAsyncComponent(() => import('./pause.vue')),
  BSvgPaymentOther: defineAsyncComponent(() => import('./payment-other.vue')),
  BSvgPaypal: defineAsyncComponent(() => import('./paypal.vue')),
  BSvgPencil: defineAsyncComponent(() => import('./pencil.vue')),
  BSvgPercentThin: defineAsyncComponent(() => import('./percent-thin.vue')),
  BSvgPercent: defineAsyncComponent(() => import('./percent.vue')),
  BSvgPerformance: defineAsyncComponent(() => import('./performance.vue')),
  BSvgPersonalSettings: defineAsyncComponent(() => import('./personal-settings.vue')),
  BSvgPet: defineAsyncComponent(() => import('./pet.vue')),
  BSvgPhone: defineAsyncComponent(() => import('./phone.vue')),
  BSvgPhoto: defineAsyncComponent(() => import('./photo.vue')),
  BSvgPinBoost: defineAsyncComponent(() => import('./pin-boost.vue')),
  BSvgPinFilled: defineAsyncComponent(() => import('./pin-filled.vue')),
  BSvgPin: defineAsyncComponent(() => import('./pin.vue')),
  BSvgPlay: defineAsyncComponent(() => import('./play.vue')),
  BSvgPlusMinus: defineAsyncComponent(() => import('./plus-minus.vue')),
  BSvgPlusSmall: defineAsyncComponent(() => import('./plus-small.vue')),
  BSvgPlusWithCircle: defineAsyncComponent(() => import('./plus-with-circle.vue')),
  BSvgPlus: defineAsyncComponent(() => import('./plus.vue')),
  BSvgPluses: defineAsyncComponent(() => import('./pluses.vue')),
  BSvgPreview: defineAsyncComponent(() => import('./preview.vue')),
  BSvgPrint: defineAsyncComponent(() => import('./print.vue')),
  BSvgProduct: defineAsyncComponent(() => import('./product.vue')),
  BSvgPromoCircle: defineAsyncComponent(() => import('./promo-circle.vue')),
  BSvgPromo: defineAsyncComponent(() => import('./promo.vue')),
  BSvgPromotionBoostCircle: defineAsyncComponent(() => import('./promotion-boost-circle.vue')),
  BSvgPromotionBoost: defineAsyncComponent(() => import('./promotion-boost.vue')),
  BSvgPromotion: defineAsyncComponent(() => import('./promotion.vue')),
  BSvgQrCode: defineAsyncComponent(() => import('./qr-code.vue')),
  BSvgQr: defineAsyncComponent(() => import('./qr.vue')),
  BSvgQuestionMark: defineAsyncComponent(() => import('./question-mark.vue')),
  BSvgRectangle: defineAsyncComponent(() => import('./rectangle.vue')),
  BSvgRedo: defineAsyncComponent(() => import('./redo.vue')),
  BSvgReferralGift: defineAsyncComponent(() => import('./referral-gift.vue')),
  BSvgReferralProgram: defineAsyncComponent(() => import('./referral-program.vue')),
  BSvgRepeat: defineAsyncComponent(() => import('./repeat.vue')),
  BSvgRepeating: defineAsyncComponent(() => import('./repeating.vue')),
  BSvgReply: defineAsyncComponent(() => import('./reply.vue')),
  BSvgReport: defineAsyncComponent(() => import('./report.vue')),
  BSvgReports: defineAsyncComponent(() => import('./reports.vue')),
  BSvgReturned: defineAsyncComponent(() => import('./returned.vue')),
  BSvgSave: defineAsyncComponent(() => import('./save.vue')),
  BSvgSearch: defineAsyncComponent(() => import('./search.vue')),
  BSvgSelectedStaffer: defineAsyncComponent(() => import('./selected-staffer.vue')),
  BSvgSendAngleCircle: defineAsyncComponent(() => import('./send-angle-circle.vue')),
  BSvgSendAngle: defineAsyncComponent(() => import('./send-angle.vue')),
  BSvgServicesSetup: defineAsyncComponent(() => import('./services-setup.vue')),
  BSvgSettings: defineAsyncComponent(() => import('./settings.vue')),
  BSvgShare: defineAsyncComponent(() => import('./share.vue')),
  BSvgShieldSecured: defineAsyncComponent(() => import('./shield-secured.vue')),
  BSvgShieldWarning: defineAsyncComponent(() => import('./shield-warning.vue')),
  BSvgShifts: defineAsyncComponent(() => import('./shifts.vue')),
  BSvgShoppingBag: defineAsyncComponent(() => import('./shopping-bag.vue')),
  BSvgSidebarHide: defineAsyncComponent(() => import('./sidebar-hide.vue')),
  BSvgSidebarShow: defineAsyncComponent(() => import('./sidebar-show.vue')),
  BSvgSign: defineAsyncComponent(() => import('./sign.vue')),
  BSvgSmallAvatar: defineAsyncComponent(() => import('./small-avatar.vue')),
  BSvgSmartphone: defineAsyncComponent(() => import('./smartphone.vue')),
  BSvgSocialMedia_2: defineAsyncComponent(() => import('./social-media-2.vue')),
  BSvgSocialMediaOffCircle: defineAsyncComponent(() => import('./social-media-off-circle.vue')),
  BSvgSocialMediaOnCircle: defineAsyncComponent(() => import('./social-media-on-circle.vue')),
  BSvgSocialMedia: defineAsyncComponent(() => import('./social-media.vue')),
  BSvgSortDown: defineAsyncComponent(() => import('./sort-down.vue')),
  BSvgSortUp: defineAsyncComponent(() => import('./sort-up.vue')),
  BSvgSort: defineAsyncComponent(() => import('./sort.vue')),
  BSvgSpecialOffersOffCircle: defineAsyncComponent(() => import('./special-offers-off-circle.vue')),
  BSvgSpecialOffersOnCircle: defineAsyncComponent(() => import('./special-offers-on-circle.vue')),
  BSvgSplitPayment: defineAsyncComponent(() => import('./split-payment.vue')),
  BSvgSquare: defineAsyncComponent(() => import('./square.vue')),
  BSvgStaff: defineAsyncComponent(() => import('./staff.vue')),
  BSvgStampsCircle: defineAsyncComponent(() => import('./stamps-circle.vue')),
  BSvgStar: defineAsyncComponent(() => import('./star.vue')),
  BSvgStripeLogo: defineAsyncComponent(() => import('./stripe-logo.vue')),
  BSvgStripe: defineAsyncComponent(() => import('./stripe.vue')),
  BSvgSubscriptionBilling: defineAsyncComponent(() => import('./subscription-billing.vue')),
  BSvgSwitchBack: defineAsyncComponent(() => import('./switch-back.vue')),
  BSvgTabletLandscape: defineAsyncComponent(() => import('./tablet-landscape.vue')),
  BSvgTabletPortrait: defineAsyncComponent(() => import('./tablet-portrait.vue')),
  BSvgTap: defineAsyncComponent(() => import('./tap.vue')),
  BSvgTelephone: defineAsyncComponent(() => import('./telephone.vue')),
  BSvgTextField: defineAsyncComponent(() => import('./text-field.vue')),
  BSvgText: defineAsyncComponent(() => import('./text.vue')),
  BSvgThumbDownFilled: defineAsyncComponent(() => import('./thumb-down-filled.vue')),
  BSvgThumbDown: defineAsyncComponent(() => import('./thumb-down.vue')),
  BSvgThumbUpFilled: defineAsyncComponent(() => import('./thumb-up-filled.vue')),
  BSvgThumbUp: defineAsyncComponent(() => import('./thumb-up.vue')),
  BSvgTickBold: defineAsyncComponent(() => import('./tick-bold.vue')),
  BSvgTickCircle: defineAsyncComponent(() => import('./tick-circle.vue')),
  BSvgTickSmall: defineAsyncComponent(() => import('./tick-small.vue')),
  BSvgTick: defineAsyncComponent(() => import('./tick.vue')),
  BSvgTicket_2: defineAsyncComponent(() => import('./ticket-2.vue')),
  BSvgTicket: defineAsyncComponent(() => import('./ticket.vue')),
  BSvgTimeBlock: defineAsyncComponent(() => import('./time-block.vue')),
  BSvgTimeChart_100: defineAsyncComponent(() => import('./time-chart-100.vue')),
  BSvgTimeChart_25: defineAsyncComponent(() => import('./time-chart-25.vue')),
  BSvgTimeChart_50: defineAsyncComponent(() => import('./time-chart-50.vue')),
  BSvgTimeChart_75: defineAsyncComponent(() => import('./time-chart-75.vue')),
  BSvgTimeChartAnimation_325: defineAsyncComponent(() => import('./time-chart-animation-325.vue')),
  BSvgTimeChartAnimation_45: defineAsyncComponent(() => import('./time-chart-animation-45.vue')),
  BSvgTimeOff: defineAsyncComponent(() => import('./time-off.vue')),
  BSvgTodo: defineAsyncComponent(() => import('./todo.vue')),
  BSvgTouch: defineAsyncComponent(() => import('./touch.vue')),
  BSvgTrashAlert: defineAsyncComponent(() => import('./trash-alert.vue')),
  BSvgTrash: defineAsyncComponent(() => import('./trash.vue')),
  BSvgTurnTracker: defineAsyncComponent(() => import('./turn-tracker.vue')),
  BSvgUpload: defineAsyncComponent(() => import('./upload.vue')),
  BSvgUserAdd: defineAsyncComponent(() => import('./user-add.vue')),
  BSvgUserAssign: defineAsyncComponent(() => import('./user-assign.vue')),
  BSvgUserTick: defineAsyncComponent(() => import('./user-tick.vue')),
  BSvgUser: defineAsyncComponent(() => import('./user.vue')),
  BSvgUsersGroupCircle: defineAsyncComponent(() => import('./users-group-circle.vue')),
  BSvgUsersGroup: defineAsyncComponent(() => import('./users-group.vue')),
  BSvgUsersGroupsCircle: defineAsyncComponent(() => import('./users-groups-circle.vue')),
  BSvgVector: defineAsyncComponent(() => import('./vector.vue')),
  BSvgVideo: defineAsyncComponent(() => import('./video.vue')),
  BSvgVisibilityPromotionOffCircle: defineAsyncComponent(() => import('./visibility-promotion-off-circle.vue')),
  BSvgVisibilityPromotionOnCircle: defineAsyncComponent(() => import('./visibility-promotion-on-circle.vue')),
  BSvgVoucher: defineAsyncComponent(() => import('./voucher.vue')),
  BSvgWaiting: defineAsyncComponent(() => import('./waiting.vue')),
  BSvgWallet: defineAsyncComponent(() => import('./wallet.vue')),
  BSvgWarningCircleOrange: defineAsyncComponent(() => import('./warning-circle-orange.vue')),
  BSvgWarningSmall: defineAsyncComponent(() => import('./warning-small.vue')),
  BSvgWarning: defineAsyncComponent(() => import('./warning.vue')),
  BSvgWeb: defineAsyncComponent(() => import('./web.vue')),
  BSvgWhatsapp: defineAsyncComponent(() => import('./whatsapp.vue')),
  BSvgX: defineAsyncComponent(() => import('./x.vue')),
  BSvgZoomIn: defineAsyncComponent(() => import('./zoom-in.vue')),
  BSvgZoomOut: defineAsyncComponent(() => import('./zoom-out.vue')),
}

export const svgList = [
  '1st',
  'add-appointment',
  'add-logo',
  'add-text',
  'additional-menu',
  'addmedia',
  'advanced-options',
  'advanced-settings',
  'agenda',
  'alert-triangle',
  'alert',
  'american-express',
  'apple-brand-dark',
  'apple-brand',
  'archive',
  'arrow-down',
  'arrow-left-small',
  'arrow-left',
  'arrow-right-small',
  'arrow-right',
  'arrow-up',
  'attach',
  'avatar-client',
  'avatar-group',
  'avatar-resource',
  'back',
  'background',
  'backspace',
  'bank-account',
  'barcode',
  'basic-calendar',
  'bcr',
  'bell',
  'billings',
  'blacklist-small',
  'blik',
  'bluetooth',
  'bookmark',
  'booksy-app',
  'booksy-b',
  'boost-icon',
  'boost-off-circle',
  'boost-on-circle',
  'boost',
  'bp-light',
  'bp-notification-no-show',
  'bp-notification-review-good',
  'bp-performance',
  'break',
  'business-details',
  'business-profile',
  'business-settings',
  'calendar-cancel',
  'calendar-clock',
  'calendar-day',
  'calendar-month',
  'calendar-parallel',
  'calendar-plus',
  'calendar-problem',
  'calendar-question',
  'calendar-resheduled',
  'calendar-week',
  'calendar',
  'camera-filled',
  'camera',
  'cancel-bold',
  'cancel-thin',
  'cancel',
  'car',
  'card',
  'cart',
  'cash-in-out',
  'cash-register',
  'cash',
  'cashback',
  'celebrate',
  'change-order',
  'chat',
  'check-promo',
  'check',
  'checkbox-icon',
  'checkout-with-hash',
  'checkout',
  'chevron-down-small',
  'chevron-down',
  'chevron-left-small',
  'chevron-left',
  'chevron-right-small',
  'chevron-right',
  'chevron-up-small',
  'chevron-up',
  'circle-close-filled',
  'circle-close',
  'circle-help-filled',
  'circle-help',
  'circle-info-filled',
  'circle-info',
  'circle-shield-warning',
  'circle-tick-filled',
  'circle-tick',
  'circle-warning-filled',
  'circle-warning',
  'circle-with-stars',
  'circle',
  'clients',
  'clock-filled',
  'clock-In',
  'clock-out',
  'clock',
  'close-circle',
  'close-register',
  'close-small',
  'close',
  'cloud',
  'consumption',
  'copy',
  'credit-card',
  'cup',
  'currency-eur',
  'currency-gbp',
  'currency-percent',
  'currency-pln',
  'currency-usd',
  'custom-form-checkbox',
  'custom-form-input',
  'custom-form-text',
  'customer-payments',
  'direction-filled',
  'direction',
  'discount',
  'divider',
  'document',
  'download-gray',
  'download',
  'drag-n-drop',
  'duplicate',
  'edit-card',
  'edit-text',
  'edit',
  'elearning',
  'expand',
  'eye-off',
  'eye',
  'facebook-brand',
  'facebook',
  'filter',
  'filters',
  'finished-break',
  'first-visit',
  'fit-calendar',
  'form',
  'format-circle',
  'format',
  'geolocation',
  'gift-card',
  'gift',
  'giftcard',
  'giftcards',
  'google-brand',
  'google-business-profile',
  'google-circle',
  'grab',
  'group-booking',
  'group-icon',
  'hamburger',
  'hash',
  'hashtag-group',
  'hear-filled',
  'heart',
  'help-small',
  'help',
  'holiday',
  'home',
  'hourglass',
  'ico_booksy-badge',
  'ico_comments',
  'ico_fb',
  'ico_ig',
  'ico_like_full',
  'ico_like',
  'ico_more',
  'ico_reward',
  'ico_send',
  'ico_share',
  'ico_square',
  'image_gray',
  'image',
  'imready',
  'info-small',
  'info',
  'instagram-brand',
  'instagram',
  'inventory-report',
  'inventory',
  'invite-client',
  'invite-customers-off-circle',
  'invite-customers-on-circle',
  'jumpstart',
  'keyed-in-payment',
  'left-top',
  'light',
  'link-out',
  'link-small',
  'location',
  'lock-filled',
  'lock',
  'logout',
  'loyalty-program',
  'magic-stars',
  'mail',
  'marketing',
  'med',
  'membership',
  'merge-filled',
  'merge',
  'message-blast-off-circle',
  'message-blast-on-circle',
  'message-edit',
  'message-search',
  'message',
  'minus-small',
  'minus',
  'mobile-payment',
  'mobile-services',
  'mobile',
  'modal-circle-error',
  'modal-circle-info',
  'modal-circle-positive',
  'modal-circle-question',
  'modal-circle-user',
  'modal-circle-warning',
  'more',
  'move-arrows',
  'nav-arrow-left',
  'nav-arrow-right',
  'new-sale',
  'no-resources',
  'no-results',
  'no-show-protection',
  'noshow',
  'note',
  'notification_trophy',
  'online-booking',
  'other-payment-method',
  'other',
  'package',
  'padlock_key',
  'paper-clip-circle',
  'paper-clip',
  'paragraph',
  'parallel-filled',
  'parallel',
  'partner-apps',
  'partner-fizjorejestracja',
  'pause',
  'payment-other',
  'paypal',
  'pencil',
  'percent-thin',
  'percent',
  'performance',
  'personal-settings',
  'pet',
  'phone',
  'photo',
  'pin-boost',
  'pin-filled',
  'pin',
  'play',
  'plus-minus',
  'plus-small',
  'plus-with-circle',
  'plus',
  'pluses',
  'preview',
  'print',
  'product',
  'promo-circle',
  'promo',
  'promotion-boost-circle',
  'promotion-boost',
  'promotion',
  'qr-code',
  'qr',
  'question-mark',
  'rectangle',
  'redo',
  'referral-gift',
  'referral-program',
  'repeat',
  'repeating',
  'reply',
  'report',
  'reports',
  'returned',
  'save',
  'search',
  'selected-staffer',
  'send-angle-circle',
  'send-angle',
  'services-setup',
  'settings',
  'share',
  'shield-secured',
  'shield-warning',
  'shifts',
  'shopping-bag',
  'sidebar-hide',
  'sidebar-show',
  'sign',
  'small-avatar',
  'smartphone',
  'social-media-2',
  'social-media-off-circle',
  'social-media-on-circle',
  'social-media',
  'sort-down',
  'sort-up',
  'sort',
  'special-offers-off-circle',
  'special-offers-on-circle',
  'split-payment',
  'square',
  'staff',
  'stamps-circle',
  'star',
  'stripe-logo',
  'stripe',
  'subscription-billing',
  'switch-back',
  'tablet-landscape',
  'tablet-portrait',
  'tap',
  'telephone',
  'text-field',
  'text',
  'thumb-down-filled',
  'thumb-down',
  'thumb-up-filled',
  'thumb-up',
  'tick-bold',
  'tick-circle',
  'tick-small',
  'tick',
  'ticket-2',
  'ticket',
  'time-block',
  'time-chart-100',
  'time-chart-25',
  'time-chart-50',
  'time-chart-75',
  'time-chart-animation-325',
  'time-chart-animation-45',
  'time-off',
  'todo',
  'touch',
  'trash-alert',
  'trash',
  'turn-tracker',
  'upload',
  'user-add',
  'user-assign',
  'user-tick',
  'user',
  'users-group-circle',
  'users-group',
  'users-groups-circle',
  'vector',
  'video',
  'visibility-promotion-off-circle',
  'visibility-promotion-on-circle',
  'voucher',
  'waiting',
  'wallet',
  'warning-circle-orange',
  'warning-small',
  'warning',
  'web',
  'whatsapp',
  'x',
  'zoom-in',
  'zoom-out',
]
